import { userToast } from 'helpers/toastMessages';

export const headerData = {
  tableName: 'Users',
  hasExport: true,
  hasSearch: true,
  hasDelete: true,
  hasEdit: true,
  hasPaging: true,
  hasCheckbox: true,
  hasUploadCSV: true,
  hasLock: true,
  deleteSubtext: userToast.deleteConfirmation,
  fields: [
    {
      fieldName: 'firstName',
      headerName: 'First Name',
      hasImage: true,
    },
    {
      fieldName: 'lastName',
      headerName: 'Last Name',
      fontWeight: 500,
    },
    {
      fieldName: 'username',
      headerName: 'Username',
    },
    {
      fieldName: 'displayEmail',
      headerName: 'Email',
    },
    {
      fieldName: 'roleName',
      headerName: 'Role',
      hasTag: true,
      hasSort: true,
    },
    {
      fieldName: 'mobile',
      headerName: 'Mobile',
      hasMobile: true,
      hasSort: true,
    },
    {
      fieldName: 'phone',
      headerName: 'Phone',
      hasMobile: true,
    },

    {
      fieldName: 'department',
      headerName: 'Department',
    },
    // {
    //   fieldName: 'averageToken',
    //   headerName: 'Token',
    // },
    {
      fieldName: 'lastLogin',
      headerName: 'Last Login',
      isDatetime: true,
    },
  ],
};
